import {Component, Injector} from '@angular/core';
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {
  CreateDeliveryPointViewModel
} from "@app/presentation/pages/create-delivery-point/create-delivery-point.view-model";
import {PopupDispatcher} from "@app/presentation/components/errors/popup.dispatcher";
import {ExitService} from "@app/presentation/services/exit.service";
import {ToastService} from "@app/presentation/services/toast/toast.service";
import {TranslateService} from "@ngx-translate/core";

@Component({
  selector: 'app-create-delivery-point',
  templateUrl: './create-delivery-point.component.html',
  styleUrls: ['./create-delivery-point.component.scss']
})
export class CreateDeliveryPointComponent {

  deliveryPointGroup = new FormGroup( {
    code: new FormControl<number | null>(null,Validators.required),
    taxId: new FormControl<string | null>(null,Validators.required)
  });

  private isCreateDeliveryPointLoading$ = this.createDeliveryPointViewModel.isCreateDeliveryPointLoading$;

  isConfirmDeliveryPointButtonLoading$ = this.isCreateDeliveryPointLoading$;

  constructor(
      private createDeliveryPointViewModel:CreateDeliveryPointViewModel,
      private popupDispatcher:PopupDispatcher,
      private injector: Injector,
      private toastService: ToastService,
      private translateService: TranslateService,
  ) {
    this.popupDispatcher.setNotifier(createDeliveryPointViewModel.notifier)
  }

  createDeliveryPoint() {
    const code = this.deliveryPointGroup.getRawValue().code;
    const taxId = this.deliveryPointGroup.getRawValue().taxId;
    if (code === null || taxId === null) {
      return;
    }
    this.createDeliveryPointViewModel
        .createDeliveryPoint({
          code: code,
          taxId: taxId,
        }).subscribe({
        next: () => {
          this.toastService.show(this.translateService.instant('action_message.delivery_point.successfully_created'));
          this.close();
        }
    })
  }

  close() {
    ExitService.exit(this.injector)
  }

}
